// Label prefixes for data sources (no emojis)
export const sourcePrefixes = {
  SITREP: 'SITREP',
  Files: 'Files',
  Web: 'Web',
  News: 'News',
  'Current Weather': 'Current Weather',
  'Forecast Weather': 'Forecast Weather',
  'Power Outages': 'Power',
  'ERI (Energy Reliability Index)': 'ERI',
  Incident: 'Incident',
  'NEO Analysis': 'NEO',
  Exercise: 'Exercise',
  Layers: 'Layers',
  Seerist: 'Seerist',
  'TAK Entities': 'TAK',
};

/**
 * Weather sources offered in chat (sitrep also includes Power/ERI via
 * LocationRequiredDataSources).
 */
export const ChatWeatherDataSources = [
  {
    source: 'Current Weather',
    description:
      'LOCATION REQUIRED (Incident). Current weather at incident location.',
    id: '',
  },
  {
    source: 'Forecast Weather',
    description:
      'LOCATION REQUIRED (Incident). Forecast weather at incident location.',
    id: '',
  },
];

export const LayersDataSource = {
  source: 'Layers',
  description:
    'Select ArcGIS-hosted or Pratus-hosted map layers. Pratus AI reads selected layer features.',
  id: '',
};

export const SeeristDataSource = {
  source: 'Seerist',
  description:
    'News & social intelligence from Seerist. Requires a Seerist API key in Organization Settings.',
  id: '',
};

/** Gated in DataSources UI by TENNESSEE_NATIONAL_GUARD. */
export const TakEntitiesDataSource = {
  source: 'TAK Entities',
  description:
    'Live TAK picture (unit positions, markers, drawn shapes). Location is auto-resolved from the current incident AOR.',
  id: '',
};

export const LocationRequiredDataSources = [
  {
    source: 'Current Weather',
    description: 'LOCATION REQUIRED (Event).  Current weather at location.',
    id: '',
  },
  {
    source: 'Forecast Weather',
    description: 'LOCATION REQUIRED (Event).  Forecast weather at location.',
    id: '',
  },
  {
    source: 'Power Outages',
    description: 'LOCATION REQUIRED (Event).  Power outages at location.',
    id: '',
  },
  {
    source: 'ERI (Energy Reliability Index)',
    description:
      'LOCATION REQUIRED (Event).  ERI (Energy Reliability Index) at location.',
    id: '',
  },
  {
    source: 'TAK Entities',
    description:
      'LOCATION REQUIRED (Event).  Live TAK entities (blue-force tracks, markers, shapes) at location.',
    id: '',
  },
];

export const DChatDataSources = [
  {
    source: 'Incident',
    description:
      'Complete incident ICS data. Auto-detects if current or historical data is needed based on your query.',
    id: '',
  },
  {
    source: 'Exercise',
    description:
      'Complete exercise planning data including scenarios, participants, objectives, and MSEL injects.',
    id: '',
  },
];
